import { render, staticRenderFns } from "./InductionTicketing.vue?vue&type=template&id=a9b2b444&scoped=true"
import script from "./InductionTicketing.vue?vue&type=script&lang=js"
export * from "./InductionTicketing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b2b444",
  null
  
)

export default component.exports